import api from '@/shared/api';
import type { ApiResponse, DocumentType } from '@/shared/lib';

export interface HomologationRevisionStage {
  inHomologation: boolean;
  documentType: DocumentType;
}

export async function fetchHomologationRevisionStage(
  revisionId: number
): Promise<HomologationRevisionStage> {
  const response = await api.get<ApiResponse<HomologationRevisionStage>>(
    `/homologations/revisions/${revisionId}/stage`
  );

  if (!response.data.data) {
    throw new Error('Estágio da revisão não encontrado.');
  }

  return response.data.data;
}
